import { useEffect, useState } from "react";

/** Live sliding ticker of recent events (timeline / alerts). */
export default function LiveTicker({ items = [] }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!items.length) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 4200);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;
  const cur = items[idx] || items[0];

  return (
    <div
      className="relative overflow-hidden bg-[#0F1530]/70 border border-white/[0.14] rounded-2xl px-5 py-3.5 backdrop-blur-md"
      data-testid="live-ticker"
    >
      <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-emerald-400 via-sky-400 to-fuchsia-400 animate-pulse"/>
      <div className="flex items-center gap-3">
        <span className="text-[10px] uppercase tracking-widest text-emerald-300 font-semibold whitespace-nowrap">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400 mr-1.5 animate-ping"/>
          Live
        </span>
        <div key={idx} className="flex-1 min-w-0 text-[13px] text-white truncate animate-fade-in-up">
          <span className="text-white font-semibold">{cur.title || cur.name}</span>
          {cur.reasoning && <span className="text-white/75"> — {cur.reasoning}</span>}
        </div>
        <div className="text-[11px] text-white/60 tabular-nums whitespace-nowrap">
          {idx + 1}/{items.length}
        </div>
      </div>
    </div>
  );
}
